import styles from '../CmsBusinessJourneyWizard.module.scss';
import React from 'react';
import { Button as BaseButton } from '@ariakit/react';
import { ChoiceCard } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const ChoiceCardsList = ({
  cards,
  headingLevel,
  storage,
  setStorage,
  setStepNumber,
}) => {
  const handleAnswer = card => {
    const newStorage = {
      ...storage,
      answers: [
        ...storage.answers,
        { title: card.cardTitle, keyword: card.keyword },
      ],
    };
    setStorage(newStorage);

    setStepNumber(currentStep => currentStep + 1);
  };
  return (
    <div
      className={classNames(styles.cardsContainer, {
        [styles.twoChoiceCards]: cards.length === 2,
      })}
    >
      {cards?.map(card => (
        <ChoiceCard
          as={BaseButton}
          glyph={card.icon}
          headingLevel={headingLevel}
          image={card.imageIcon}
          key={card.cardTitle}
          onClick={() => handleAnswer(card)}
          title={card.cardTitle}
        />
      ))}
    </div>
  );
};

export default ChoiceCardsList;
